<template>
    <div class="container" v-touch-swipe.noMouse.left.right="userHasSwiped" :style="container_style">
        <!-- <div @click="goLeft()" class="arrowleft" :style="is_full_screen && !disableButtonPrevious ? 'display: block' : 'display: none'"></div> -->

        <v-zoomer class="player" :style="player_style" pivot='cursor' :limitTranslation="false">
            <div class="player" :style="player_style">
                <img :src="getSlide" class="slide" :style="slide_style" style="object-fit: contain;" />
            </div>
        </v-zoomer>

        <!-- <div @click="goRight()"  class="arrowright" :style="is_full_screen && !disableButtonNext ? 'display: block' : 'display: none'"></div> -->

        <div class="controller bg-primary"  :style="controller_style">
            <q-btn color='white' size="lg" flat @click="goLeft()" icon="fal fa-chevron-left" :disable="disableButtonPrevious" />
            <q-btn color='white' size="lg" flat @click="goRight()" icon="fal fa-chevron-right" :disable="disableButtonNext" />
            <q-btn color='white' size="lg" flat @click="fullScreen()" class="fullscreen" icon="fal fa-compress" />
        </div>
    </div>
</template>

<script>
import { AppFullscreen } from 'quasar'
import { mapGetters } from 'vuex'
export default {
    props: ['file_url', 'file_preview', 'change_state'],

    data() {
        return {
            id_course: '',
            slides: [],
            slide: {},
            current_slide: 0,
            loading: false,
            is_full_screen: false,
            container_style:'',
            player_style: '',
            slide_style: '',
            controller_style: ''
        }
    },

    computed: {
        disableButtonPrevious() {
            if (this.loading) return true
            return this.current_slide === 0 ? true : false
        },

        disableButtonNext() {
            if (this.loading) return true
            return this.current_slide + 1 == this.slides.length ? true : false
        },

        getSlide() {
            return this.slide ? this.slide.image : ''
        },
    },

    methods: {
        getSlides() {
            if (this.file_preview) {
                this.slides = this.file_preview.map(e => ({ ...e, image: e.file }))
                if (this.slides.length > 0) this.slide = this.slides[0]
            }
            else this.slides = []
        },

        userHasSwiped(obj){
            if(obj.direction === 'left') this.goRight()
            else if(obj.direction === 'right') this.goLeft()
        },

        goLeft() {
            if(this.current_slide > 0){
                this.current_slide = this.current_slide - 1
                this.slide = this.slides[this.current_slide]
            }
        },

        goRight() {
            if(this.current_slide < this.slides.length - 1){
                this.current_slide = this.current_slide + 1
                this.slide = this.slides[this.current_slide]
            }
        },

        fullScreen(origin) {
            if (!this.$q.platform.is.cordova) {
                if (!this.is_full_screen) {
                    this.enterFullScreen()
                    if(!this.$q.platform.is.safari) {
                        this.$q.fullscreen.request()
                    }
                }
                else {
                    this.exitFullScreen()
                    if(!this.$q.platform.is.safari) {
                        this.$q.fullscreen.exit()
                    }
                }
            }
            else if (this.$q.platform.is.cordova) {
                let options = {
                    share: false,
                    closeButton: false,
                    copyToReference: false,
                    headers: '',
                    piccasoOptions: { }
                }

                PhotoViewer.show(this.getSlide, '', options)
            }
        },

        enterFullScreen() {
            this.is_full_screen = true
            this.$emit('display', 'none')
            this.container_style = 'display:block; z-index: 9999; position:fixed; top:0; height:auto; left:0; bottom:0; right:0; overflow:auto;'
            if(this.$q.platform.is.mobile) {
                this.controller_style = 'position:absolute; width:100%; height:9vh; padding:0px;'
                this.player_style = 'width:auto; display:flex; height:91vh; justify-content:center;'
                    this.slide_style = 'width:auto; height:91vh;'
            }
            else {
                this.controller_style = 'position:absolute; width:100%; height:5vh; padding:0px;'
                this.player_style = 'width:auto; display:flex; justify-content:center;'
                this.slide_style = 'width:auto; height:95vh;'
            }
        },

        exitFullScreen() {
            this.is_full_screen = false
            this.$emit('display', 'flex')
            this.container_style = ''
            this.player_style = ''
            this.slide_style = ''
            this.controller_style = ''
        }
    },

    watch: {
        file_preview: {
            handler: function(newValue) {
                this.getSlides()
            },
            deep: true
        }
    },

    created() {
        this.getSlides()

        if (this.$q.platform.is.mobile && !this.$q.platform.is.safari) {
            window.addEventListener("orientationchange", () =>{
                if (screen.orientation.type.includes('portrait')) {
                    this.$q.fullscreen.exit()
                    this.exitFullScreen()
                }
                else if (screen.orientation.type.includes('landscape')) {
                    this.$q.fullscreen.request()
                    this.enterFullScreen()
                }
            })
        }

        document.addEventListener("fullscreenchange", (e) => {
            if(!document.fullscreenElement) {
                this.exitFullScreen()
            }
        });

        document.addEventListener("webkitfullscreenchange", (e) => {
            if(!document.fullscreenElement) {
                this.exitFullScreen()
            }
        });

        document.addEventListener("keydown", (e) => {
            switch (e.keyCode) {
                case 37: this.goLeft()
                break
                case 39: this.goRight()
                break
            }
        })
    },
    destroyed() {
        document.removeEventListener("keydown", () => {})
        document.removeEventListener("fullscreenchange", () => {})
        if (this.$q.platform.is.mobile && !this.$q.platform.is.safari) {
            document.removeEventListener("orientationchange", () => {})
        }
    }
}
</script>

<style lang="stylus" scoped>
.container
    display flex
    flex-direction column
    justify-content center
    align-items center
    background-color #000

.player
    width 49vw
    background-color black
    justify-content center

.slide
    height 55vh

.controller
    display flex
    width 100%
    justify-content center
    align-items center
    height 50px
    position relative

.arrowleft
    position absolute
    height 100vh
    width 10%
    display none
    cursor w-resize

.arrowright
    position absolute
    right 0
    top 0
    height 100vh
    width 10%
    display none
    cursor e-resize

.fullscreen
    position absolute
    width 50px
    margin-right 20px


@media (min-width: 375px)
    .slide
        height 25vh

    .player
        width: 85vw

    .controller
        width 87vw


@media (min-width: 768px)
    .slide
        height 30vh

@media (min-width: 1200px)
    .slide
        height 55vh

    .player
        width: 58vw

    .controller
        width 60vw

@media (width: 1024px), (height: 1366px)
    .slide
        height 25vh

    .player
        width: 56vw

    .controller
        width 56vw

</style>

